export const MOBILE_ISSUES_COLUMN_LABELS = {
	ISSUE_TYPE: 'Issue Type',
	SEVERITY: 'Severity',
	APP_ID: 'App ID',
	ELEMENT_DESCRIPTION: 'Element Description',
	FOUND_BY: 'Found By',
	SESSION_OR_TEST: 'Session / Test',
	USER: 'User',
	FIRST_SEEN: 'First seen',
	LAST_SEEN: 'Last seen',
	INSTANCE_COUNT: 'Instances',
	ISSUE_DETAILS: 'Issue Details'
} as const;
